/** Versión publicada del panel, tal como figura en `apps/client/package.json`. */
export const APP_VERSION = __APP_VERSION__;

/** Base URL of the API, without a trailing slash. */
export const API_URL = (
  globalThis.window?.rondaDesktop?.apiBaseUrl ??
  import.meta.env.VITE_API_URL ??
  "http://localhost:3000"
).replace(/\/+$/, "");

/**
 * Mínimo de caracteres de una contraseña, en el panel.
 *
 * Tiene que coincidir con `minPasswordLength` de `apps/api/src/auth.ts`: el
 * servidor es el que rechaza, y si acá pedimos menos, el formulario deja
 * mandar algo que vuelve con error.
 */
export const MIN_PASSWORD_LENGTH = 8;
